// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-fda9b836] .el-table th>.cell{font-size:12px;font-weight:400}[data-v-fda9b836] .el-table th{padding:10px 0;line-height:16px}", ""]);
// Exports
module.exports = exports;
